module.exports = __webpack_public_path__ + "static/img/ts4.cffa62da.png";